const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function formatReportCurrency(amount: number): string {
  return currencyFormatter.format(amount);
}

/** Formats an API `YYYY-MM-DD` date without going through `new Date(string)`, which would parse it as UTC
 * and can display the previous day in negative-offset time zones. Unparseable input is shown unchanged. */
export function formatReportDate(isoDate: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate);
  if (!match) return isoDate;
  const local = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return local.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}
